"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = void 0;
const tslib_1 = require("tslib");
const isArray_1 = (0, tslib_1.__importDefault)(require("lodash/isArray"));
const required = (value) => {
    if (value === '' || value === undefined || value === null) {
        return { message: 'Required.' };
    }
    if ((0, isArray_1.default)(value) && value.length === 0) {
        return { message: 'Required.' };
    }
};
exports.required = required;
//# sourceMappingURL=required.js.map